import { TrophyIcon } from '@heroicons/react/20/solid'

interface SeasonEndedBadgeProps {
  text: string
  className?: string
}

const SeasonEndedBadge = ({ text, className }: SeasonEndedBadgeProps) => (
  <span
    className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-th-warning/15 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-th-warning ${
      className ?? ''
    }`}
  >
    <TrophyIcon className="size-2.5" />
    {text}
  </span>
)

export default SeasonEndedBadge
